import { useTranslation } from 'react-i18next'
import type { FxQuoteDto } from '@/lib/types'

/** USP #3 — mid-market rate shown ABOVE our rate; margin always declared. */
export function RealRateDisplay({ quote, locale }: { quote: FxQuoteDto; locale: string }) {
  const { t } = useTranslation('banking')
  const fmt = (n: number) =>
    new Intl.NumberFormat(locale, { maximumFractionDigits: 4 }).format(n)

  const midLine = `1 ${quote.base} = ${fmt(quote.mid_market_rate)} ${quote.quote}`
  const ourLine = `1 ${quote.base} = ${fmt(quote.our_sell_rate)} ${quote.quote}`
  const spreadLine = `${t('fx.spread')} · ${quote.margin_percent}%`

  return (
    <div className="rounded-2xl border border-border bg-bg-subtle p-4">
      <p className="text-xs uppercase tracking-wide text-text-muted">{t('fx.mid_market')}</p>
      <p className="font-mono text-2xl">{midLine}</p>

      <p className="mt-3 text-xs uppercase tracking-wide text-text-muted">{t('fx.our_rate')}</p>
      <p className="font-mono text-lg">{ourLine}</p>

      <p className="mt-3 text-xs text-text-subtle">{spreadLine}</p>
    </div>
  )
}
